import { useMemo } from "react";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

import { computeSuitabilityInpData } from "../SuitabilityForm.rules";
import { SuitabilityData, suitabilitySchema } from "../SuitabilityForm.schema";
import { PendingOrder } from "../SuitabilityForm.types";

import { QueryModelPosition, QueryProfile } from "@/api/queries/types";
import { Portfolio } from "@/api/types";

export function useSuitabilityForm(
  profileData: QueryProfile[] = [],
  portfolios: Portfolio[] = [],
  pendingOrders: PendingOrder[] = [],
  modelsData: QueryModelPosition[] = []
) {
  const inpData = useMemo(
    () =>
      computeSuitabilityInpData(
        profileData,
        portfolios,
        pendingOrders,
        modelsData
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      profileData.length,
      portfolios.length,
      pendingOrders.length,
      modelsData.length,
    ]
  );

  return useForm<SuitabilityData>({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: zodResolver(suitabilitySchema) as any,
    values: {
      dpInvType: inpData.knowledgeAndExperience ?? "",
      dpFinancialSituation: inpData.financialSituation ?? "",
      dpInvTime: inpData.timeHorizon ?? "",
      dpRisktolerance: inpData.riskTolerance ?? "",
      dpRiskpreferenceAndInvestmentGoals:
        inpData.riskpreferenceAndInvestmentGoals ?? "",
      dpEsgPreference: inpData.esgPreference ?? "",
      dpInitStockPart: inpData.stockpartBefore ?? "",
      dpFinStockPart: inpData.stockpartAfter ?? "",
      dpSystemAdvice: inpData.systemAdvice ?? "",
      useInputFromCustomerAgreementInSuitabilityStatement: false,
      dpAdvAdvice: "",
      dpAdvAdviceESG: "",
    },
  });
}
